module.exports = __webpack_public_path__ + "img/header-image.95535d77.png";